export default __webpack_public_path__ + "static/media/10-TheBoathouse.72d39e3d.jpeg";